const state = {
  endpoints: {
    data: [],
  },

  endpoint: {
    name: '',
    label: '',
    path: '',
    value: 0,
    tags: [],
    enable: false,
    fields: {},
  },
};

export default state;
